export { default as LocalStore } from "./LocalStore";

export const roundNumber = (number, decimals) => {
    decimals = decimals || 2;
    let multi = parseInt("1" + "0".repeat(decimals));
    return Math.round(number * multi) / multi;
}
